import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from './../../../UiComponents/Dialog';
import getLabel from './../../../../utils/labels'
import tickIcon from './../../../../globals/images/survey-completed.svg'
import styles from './surveyCompleted.module.scss';

class SurveyCompleted extends Component {
    render() {
        return (
            <Dialog
                overlayClassName={styles.submitteddialog}
                isFooterNeeded={false}
            >
                <div className={styles['submitted-screen']}>
                    <div className={styles.message}>
                        <img
                            src={tickIcon}
                        />
                        <div>{this.props.text}</div>
                    </div>
                    <div className={styles.closeButton} onClick={() => this.props.closeSurvey()}>{getLabel('label_continue_button')}</div>
                </div>
            </Dialog>
        )
    }
}

export default SurveyCompleted


// WEBPACK FOOTER //
// /src/components/commonComponents/surveyView/surveyCompleted/SurveyCompleted.js